import { actionCreator } from 'utils';
import * as CarrierTypes from '../types/carrierTypes';

// L O A D   C A R R I E R S   W I T H   P A G I N A T I O N   &   S O R T
export function loadCarriers() {
    return {
        type: CarrierTypes.LOAD_CARRIERS,
    };
}

export function loadCarriersRes(data) {
    return {
        type: actionCreator(CarrierTypes.LOAD_CARRIERS, 'res'),
        data,
    };
}

export function loadCarriersErr() {
    return {
        type: actionCreator(CarrierTypes.LOAD_CARRIERS, 'err'),
    };
}
// L O A D   C A R R I E R S


// S E T   C A R R I E R   F I L T E R S   W I T H   P A G I N A T I O N   &   S O R T
export function setCarrierFilters(key, value) {
    return {
        type: CarrierTypes.SET_CARRIER_FILTER,
        key,
        value,
    };
}

export function setCarrierFiltersRes(data) {
    return {
        type: actionCreator(CarrierTypes.SET_CARRIER_FILTER, 'res'),
        data,
    };
}

export function setCarrierPagination(key, pagination) {
    return {
        type: CarrierTypes.SET_CARRIER_PAGINATION,
        key,
        pagination,
    };
}

export function setCarrierSort(key, type) {
    return {
        type: CarrierTypes.SET_CARRIER_SORT,
        sort: {
            key,
            type,
        },
    };
}
// S E T   C A R R I E R   F I L T E R S   W I T H   P A G I N A T I O N   &   S O R T


// A D D   N E W   C A R R I E R
export function addNewCarrier(data) {
    return {
        type: CarrierTypes.ADD_NEW_CARRIER,
        data,
    };
}

export function addNewCarrierRes(loading, success) {
    return {
        type: actionCreator(CarrierTypes.ADD_NEW_CARRIER, 'res'),
        loading,
        success,
    };
}

export function addNewCarrierErr(error) {
    return {
        type: actionCreator(CarrierTypes.ADD_NEW_CARRIER, 'err'),
        error,
    };
}
// A D D   N E W   C A R R I E R


// E D I T   C A R R I E R
export function editCarrier(data) {
    return {
        type: CarrierTypes.EDIT_CARRIER,
        data,
    };
}

export function editCarrierRes(loading, success) {
    return {
        type: actionCreator(CarrierTypes.EDIT_CARRIER, 'res'),
        loading,
        success,
    };
}

export function editCarrierErr() {
    return {
        type: actionCreator(CarrierTypes.EDIT_CARRIER, 'err'),
    };
}

export function editCarrierFormProperties(properties) {
    return {
        type: CarrierTypes.EDIT_CARRIER_FORM_PROPERTIES,
        properties,
    };
}
// E D I T   C A R R I E R


// L O A D   E D I T A B L E   C A R R I E R
export function loadEditableCarrier(id) {
    return {
        type: CarrierTypes.LOAD_EDITABLE_CARRIER,
        id,
    };
}

export function loadEditableCarrierRes(data) {
    return {
        type: actionCreator(CarrierTypes.LOAD_EDITABLE_CARRIER, 'res'),
        data,
    };
}

export function loadEditableCarrierErr() {
    return {
        type: actionCreator(CarrierTypes.LOAD_EDITABLE_CARRIER, 'err'),
    };
}

export function setEmptyEditableCarrier() {
    return {
        type: CarrierTypes.SET_EMPTY_EDITABLE_CARRIER,
    };
}
// L O A D   E D I T A B L E   C A R R I E R
